import { Component, OnInit } from '@angular/core';
import { CognitoUserPool, CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';
import { NgForm } from '@angular/forms';
import { AuthorizationService } from '../service/authorization.service';
/**
 * Forcing rebuild: #04
 */
const poolData = {
    UserPoolId: 'us-east-1_TbCztitd3', // Your user pool id here
    ClientId: '5059c7r153gibf72ca80tm93k' // Your client id here
};
const userPool = new CognitoUserPool(poolData);

@Component({
  selector: 'dhi-email-confirm',
  templateUrl: './email-confirm.component.html',
  styleUrls: ['./email-confirm.component.scss']
})
export class EmailConfirmComponent implements OnInit {
    public code: string;
    public username: string;
    confirmCode = false;
    codeWasConfirmed = false;
    error = '';
    emailAddress = '';
    successful = false;
    failure = false;

  constructor(  private auth: AuthorizationService,
    ) {
        const url = document.location.href;
        const x = url.split('?c=').pop();
        this.code = x.split('&')[0];

        const z = url.split('&u=').pop();
        this.username = z.split('&')[0];

        const email = url.split('&e=').pop();
        this.emailAddress = email;

     }

  ngOnInit(): void {
        this.validateAuthCode();
  }

  validateAuthCode() {
    const code = this.code;
    const username = this.username;

    this.auth.confirmAuthCode(code, username ).subscribe(
        data => {
            // this._router.navigateByUrl('/');
            this.codeWasConfirmed = true;
            this.confirmCode = false;
            this.successful = true;
        },
        err => {
            console.log(err);
            this.error = 'Confirm Authorization Error has occurred';
            this.failure = true;
        }
    );
}

}
